import React from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/AuthProvider";
import Cookies from "js-cookie";

class Logout extends React.Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  componentDidMount() {
    this.handleLogout();
  }

  handleLogout() {
    var self = this;
    var setAuth = this.context.setAuth;

    fetch(process.env.REACT_APP_URL + "/logout", {
      method: "POST",
      credentials: "include"
    })
      .then(function () {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("lu");
        sessionStorage.removeItem("auth");
        localStorage.removeItem("auth");
        localStorage.removeItem("myc_pwa_dismissed_at");
        setAuth({});
        self.setState({ redirect: true });
      })
      .catch(function () {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("lu");
        sessionStorage.removeItem("auth");
        localStorage.removeItem("auth");
        localStorage.removeItem("myc_pwa_dismissed_at");
        setAuth({});
        self.setState({ redirect: true });
      });
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to="/Login" replace />;
    }

    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h3>Logging out...</h3>
      </div>
    );
  }
}

export default Logout;
